import { render, staticRenderFns } from "./RewardsList.vue?vue&type=template&id=7fe3fbf2&scoped=true&"
import script from "./RewardsList.vue?vue&type=script&lang=ts&"
export * from "./RewardsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe3fbf2",
  null
  
)

export default component.exports